import React, { useMemo } from "react";

import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { COLUMN_HEADER_KEYS, RULE_TYPES } from "globals/constants";
import { useDictionary } from "hooks";
import { useRuleBuilderContext } from "containers/Rules/context/useRuleBuilderContext";
import { useTeamLabel } from "../../ActionBuilder/utils";

export const useRuleTypeActionLabel = (ruleType) => {
    const { formType = "" } = useRuleBuilderContext();

    const getLabelsForForm = () => {
        switch (formType.toUpperCase()) {
            case COLUMN_HEADER_KEYS.PROPOSAL:
                return "ruleBuilder.actionBuilder.actionLabels.proposalForm";
            case COLUMN_HEADER_KEYS.AWARD:
                return "ruleBuilder.actionBuilder.actionLabels.awardForm";
            default:
                return "ruleBuilder.actionBuilder.actionLabels.default";
        }
    };

    const dictionary = useDictionary(getLabelsForForm());

    return useMemo(() => {
        return isNonEmptyString(dictionary[ruleType])
            ? dictionary[ruleType]
            : ruleType;
    }, [dictionary, ruleType]);
};

export const useActionText = (rule) => {
    const teamLabel = useTeamLabel(rule.targetId);
    const actionLabel = useRuleTypeActionLabel(rule.ruleType);

    switch (rule.ruleType) {
        case RULE_TYPES.AD_HOC_NOTIFICATION:
        case RULE_TYPES.AD_HOC_REVIEW:
        case RULE_TYPES.INFOREADY_REVIEW:
            return (
                <>
                    <span
                        dangerouslySetInnerHTML={{ __html: actionLabel }}
                    />
                    <span> {teamLabel}</span>
                </>
            );
        default:
            return (
                <span dangerouslySetInnerHTML={{ __html: actionLabel }} />
            );
    }
};
